import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Toast } from '../hooks/useToast';
import { PostReport } from '../Api/PostReport';
import { setStatus as postManagementStatus } from './PostManagementReducer';
import { setStatus as dashboardStatus } from './DashboardReducer';

export const fetchPostReportThunk = createAsyncThunk(
    'postReport/fetch',
    async (_, { getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await PostReport.fetch({ api_token });
            return response.data
        } catch (err) {
            Toast(err.message, 'error', false)
            return Promise.reject(err);
        }
    }
)

export const deleteUserReportedPostThunk = createAsyncThunk(
    'postReport/delete',
    async ({ post_slug }, { dispatch, getState }) => {
        try {
            Toast('Deleting Post', 'loading', true);
            const { api_token } = getState().profile.data;
            const response = await PostReport.delete({ post_slug, api_token });
            dispatch(postManagementStatus({ status: "pending" }))
            dispatch(dashboardStatus({ status: "pending" }))
            Toast('Post deleted successfully', 'success', false);
            return post_slug
        } catch (err) {
            Toast(err.message, 'error', false);
            return Promise.reject(err.message);
        }
    }
)

const initialState = {
    status: "pending",
    data: [],
}

export const postReportSlice = createSlice({
    name: 'postReport',
    initialState,
    reducers: {
        setStatus: (state, actions) => {
            return {
                ...state,
                ...actions.payload
            }
        },
        resetState: () => {
            return initialState
        },

    },
    extraReducers: {
        [fetchPostReportThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [fetchPostReportThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [deleteUserReportedPostThunk.fulfilled]: (state, action) => {
            state.data = state.data.filter(item => item.post_slug !== action.payload)
            state.status = "success"
        },

    }
})


// Action creators are generated for each case reducer function
export const { setStatus, resetState } = postReportSlice.actions

export default postReportSlice.reducer